import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-maxC mtop-12 mleft-04"
}
const _hoisted_2 = {
  key: 1,
  class: "history-grid history-container mtop-06"
}

import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import loadingSpinner from '@/views/loadingSpinner.vue';
import { ExpressionsApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { DateFormat } from '@/models/share.model';
import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'editExpressionHistory',
  props: {
  expression: {
    type: Object,
    required: true,
  },
  entry: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const expressionsApi = new ExpressionsApi(medServerApiConfig);
const { t } = useI18n();
const props = __props

const history = ref([]);
async function loadHistory() {
  const expressionId = props.expression.expressionId;
  history.value = await expressionsApi.getExpressionHistory({id: expressionId});
}

onMounted(() => {
  loadHistory()
})

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal",
    style: {"height":"15rem","width":"35rem"},
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_text_item, {
      txt: _unref(t)('patient.expression.history'),
      styles: "font-mBold main-h"
    }, null, 8, ["txt"]),
    (!history.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(loadingSpinner, {
            logo: false,
            style: 'w-3'
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(history.value, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createVNode(_component_text_item, {
                txt: item.newValue
              }, null, 8, ["txt"]),
              _createVNode(_component_text_item, {
                txt: _unref(format)(new Date(item.correctedAt), _unref(DateFormat).DATE_TIME_FR_SMALL),
                styles: "font-s main-m"
              }, null, 8, ["txt"]),
              _createVNode(_component_text_item, {
                txt: item.correctedBy,
                styles: "font-s main-m"
              }, null, 8, ["txt"])
            ], 64))
          }), 128)),
          _createVNode(_component_text_item, {
            txt: history.value.at(-1).oldValue
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(format)(new Date(props.entry.entryStart), _unref(DateFormat).DATE_TIME_FR_SMALL),
            styles: "font-s main-m"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: props.entry.healthPro.lastName + ' ' + props.entry.healthPro.firstName,
            styles: "font-s main-m"
          }, null, 8, ["txt"])
        ]))
  ]))
}
}

})